import { useContext } from 'react';

import { useMutation, useQueryClient } from 'react-query';

import { AlertSnackbarContext } from '../../../components/snackbars';
import Api from '../../api/api';

export const approvePostRequestOverride = async (requestId: string) => {
  const [response, bodyOrError] = await Api.patch(`posts/requests/${requestId}/approve`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return response;
};

export const useApprovePostRequestOverride = () => {
  const queryClient = useQueryClient();

  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);

  return useMutation(
    'approvePostRequestOverride',
    (data: { requestId: string }) => {
      return approvePostRequestOverride(data.requestId);
    },
    {
      onSuccess: (data, vars, ctx) => {
        queryClient.invalidateQueries('getAllPostRequests');
        queryClient.invalidateQueries('getPostRequestOverride');
        setAlertSnackbar({
          message: 'Post request override approved successfully',
          severity: 'success',
        });
      },
      onError: (error: any) => {
        setAlertSnackbar({
          message: error?.message || 'An error occurred while approving the post request override',
          severity: 'error',
        });
      },
    },
  );
};
